<template>
    <div class="NoteView">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>쪽지 읽기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_close.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <!-- 보낸사람 -->
            <div class="title-area" v-if="pNoteTab == 'receive'">
                <div class="label-text">보낸 사람</div>
                <div class="label-content"><strong>{{ detail.strSendNickName }}</strong>
                    ({{ detail.strSendUserId | idHidden }})
                </div>
            </div>
            <!-- 받은사람 -->
            <div class="title-area" v-else>
                <div class="label-text">받은 사람</div>
                <div class="label-content"><strong>{{ detail.strReceiveNickName }}</strong>
                    ({{ detail.strReceiveUserId | idHidden }})
                </div>
            </div>
            <div class="title-area">
                <div class="label-text">{{ (pNoteTab == 'receive') ? '받은 날짜' : '받은 날짜' }}</div>
                <div class="label-content">{{ detail.strRegDate }}</div>
            </div>
            <div class="note-content" v-html="detail.strMessage "></div>

            <footer class="footer-note">
                <div class="flex justify-between ">
                    <button class="btn-big btn-gray mrg-right-10"
                            v-if="pNoteTab == 'send' && detail.bCancelSend == true"
                            @click="cancelNoteMessageFunc">
                        발송취소
                    </button>
                    <button class="btn-big btn-white mrg-right-10"
                            @click="deleteNoteMessageFunc">
                        삭제
                    </button>
                    <button class="btn-big btn-bule mrg-right-10"
                            v-if="pNoteTab == 'receive'"
                            @click="noteWriteSlideView">
                        답장
                    </button>
                    <button class="btn-big btn-bule mrg-right-10"
                            v-else
                            @click="noteWriteSlideView">
                        쪽지
                    </button>
                </div>
            </footer>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>

import {MessageBox} from "mint-ui";

export default {
    name: 'NoteView',
    props: ['pNoteTab','pIdx'],
    data() {
        return {
            detail: {
                strSendUserId:'',
                strReceiveUserId:''
            }       // 쪽지 상세정보
        }
    },
    filters: {
        // 일부 아이디 히든처리
        idHidden:function (str){
            return str.substring(0,str.length-3)+'***';
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.getMessageFuncDetail();
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 쪽지 상세내용
        getMessageFuncDetail(){
            let param = {};
            this.ajaxGetAuth('/api/v1/message/'+this.pNoteTab+'/detail/'+this.pIdx, param, this.getMessageFuncDetailResult);
        },
        // 쪽지 상세내용 결과
        getMessageFuncDetailResult(response){
            if (response.result.code == 0){
                this.detail = response.oMessageInfo.detail;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 발송취소
        cancelNoteMessageFunc(){
            MessageBox({
                title: '',
                message: '이 쪽지를 발송 취소하시겠습니까?',
                showCancelButton:true,
                cancelButtonText: '취소',
                confirmButtonText: '확인'
            }).then(action => {
                if (action == 'confirm'){
                    let formData = new FormData();
                    formData.append('nSendMessageNum', this.detail.nSendMessageNum);
                    formData.append('nReceiveMessageNum', this.detail.nReceiveMessageNum);
                    this.ajaxPostAuth('/api/v1/message/send/cancel', formData, this.cancelNoteMessageFuncResult);
                }
            })
        },
        // 발송취소 결과
        cancelNoteMessageFuncResult(response){
            let result = response.result;
            if (result.code == 0){
                this.slidePanelClose('reload');
            }else{
                if (result.resultNoti.type == 'alert'){
                    this.toastMsg(result.resultNoti.message, 1500)
                }else{
                    this.errorMsg=result.resultNoti.message;
                    this.errorField=result.resultNoti.validationFail.id;
                }
            }
        },
        // 쪽지 삭제
        deleteNoteMessageFunc(){
            MessageBox({
                title: '',
                message: this.pNoteTab == 'receive' ? '받은 쪽지를 삭제하시겠습니까?' : '보낸 쪽지를 삭제하시겠습니까?',
                showCancelButton:true,
                cancelButtonText: '취소',
                confirmButtonText: '확인'
            }).then(action => {
                if (action == 'confirm'){
                    let formData = new FormData();
                    formData.append('strMessageNums', this.pIdx);
                    this.ajaxPostAuth('/api/v1/message/'+this.pNoteTab+'/list/delete', formData,this.deleteNoteMessageFuncResult);
                }
            })
        },
        // 쪽지 삭제 결과
        deleteNoteMessageFuncResult(response){
            let result = response.result;
            if (result.code == 0){
                this.slidePanelClose('reload');
            }else{
                if (result.resultNoti.type == 'alert'){
                    this.toastMsg(result.resultNoti.message, 1500)
                }else{
                    this.errorMsg=result.resultNoti.message;
                    this.errorField=result.resultNoti.validationFail.id;
                }
            }
        },
        // 쪽지 답장 Slide
        noteWriteSlideView(){
            let props = {
                pNoteTab : this.pNoteTab,
                pIdx :this.pIdx,
            };
            const panel =this.$showPanel({
                component: () => import('@/views/slide/NoteWrite'),
                props: props,
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
                if (result == "sendReload"){
                    this.slidePanelClose('sendReload');
                }
            });
        },
    }
}
</script>

<style scoped>
    .title-area .label-text {flex-basis: 60px;}
    .slidePanel-title h2{ font-weight: 500;}
    .note-content {font-size: 16px; padding-top: 15px;margin-bottom: 120px;word-break: break-all;}
    footer {position: fixed !important; bottom: 0px;left: 0;right: 0;border-top: 1px solid #dfdfdf;padding: 20px 10px; background: #fff}
</style>
